module.exports = __webpack_public_path__ + "img/branches-logo.c75ad74e.svg";